import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
// import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'

i18n
  .use(XHR)
  // .use(Cache)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    lng: 'fr',
    supportedLngs: ['fr'],
    fallbackLng: 'fr',
    // have a common namespace used around the full app
    ns: ['common', 'nav'],
    debug: false,

    // cache: {
    //   enabled: true
    // },

    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      format: function (value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase()
        return value
      }
    },
    backend: {
      allowMultiLoading: true,
      loadPath: '/app/locales/resources.json?lng={{lng}}&ns={{ns}}'
    },
    react: {
      wait: true
    }
  })

export { i18n }



// WEBPACK FOOTER //
// ./src/vendors/i18n.js